import { render } from "./SelectTrabajador.vue?vue&type=template&id=b4595a88&scoped=true"
import script from "./SelectTrabajador.vue?vue&type=script&lang=js"
export * from "./SelectTrabajador.vue?vue&type=script&lang=js"

import "./SelectTrabajador.vue?vue&type=style&index=0&id=b4595a88&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4595a88"]])

export default __exports__